var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDevBox = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6237_277418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1474 15.6507C32.0994 13.938 31.4424 12.2985 30.2944 11.0265C29.1464 9.75461 27.5827 8.93351 25.884 8.7107C25.7813 6.31762 24.7392 4.06148 22.9839 2.43166C21.2287 0.801826 18.9016 -0.0703009 16.5075 0.00443599C14.574 -0.0328645 12.6766 0.530991 11.0772 1.61816C9.4779 2.70532 8.25553 4.26218 7.57883 6.07376C5.53268 6.32145 3.64301 7.29424 2.25257 8.81568C0.862121 10.3371 0.0629537 12.3065 0 14.3667C0.0889044 16.6803 1.09154 18.8644 2.78814 20.44C4.48472 22.0157 6.73682 22.8543 9.05077 22.7723L9.84936 22.7409H24.5153C24.6469 22.7388 24.7774 22.7187 24.9036 22.6815C26.7832 22.6667 28.585 21.9281 29.9339 20.6193C31.283 19.3105 32.0757 17.5321 32.1474 15.6538V15.6507Z",
    fill: "url(#paint0_linear_6237_277418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7049 13.5723H12.3651C11.8258 13.5723 11.3887 14.0094 11.3887 14.5487V32.1242C11.3887 32.6636 11.8258 33.1007 12.3651 33.1007H39.7049C40.244 33.1007 40.6814 32.6636 40.6814 32.1242V14.5487C40.6814 14.0094 40.244 13.5723 39.7049 13.5723Z",
    fill: "url(#paint1_linear_6237_277418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9098 39.0078C29.0131 38.5522 28.8992 36.4692 28.8992 33.1006H23.1547C23.1547 36.4692 23.057 38.5522 20.1603 39.0078C19.7604 39.0522 19.3911 39.2428 19.1236 39.5435C18.8562 39.8439 18.7095 40.233 18.7119 40.6352H33.3582C33.3607 40.233 33.214 39.8439 32.9466 39.5435C32.679 39.2428 32.3098 39.0522 31.9098 39.0078Z",
    fill: "url(#paint2_linear_6237_277418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3489 22.5765L18.8767 22.0503L23.0309 26.2163C23.0756 26.2609 23.1006 26.3217 23.1006 26.385C23.1004 26.4484 23.0751 26.5092 23.0302 26.5538L22.5026 27.0802C22.4577 27.1249 22.397 27.1499 22.3336 27.1499C22.2703 27.1497 22.2096 27.1244 22.1649 27.0795L18.3469 23.2508C18.2575 23.1611 18.2073 23.0397 18.2075 22.913C18.2077 22.7864 18.2582 22.6649 18.3479 22.5755L18.3489 22.5765Z",
    fill: "url(#paint3_linear_6237_277418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8688 23.7794L18.3425 23.2517C18.2531 23.1621 18.2029 23.0405 18.2031 22.9139C18.2033 22.7872 18.2538 22.6658 18.3435 22.5763L22.239 18.6918C22.2839 18.647 22.3446 18.622 22.408 18.6221C22.4713 18.6222 22.532 18.6474 22.5767 18.6922L23.103 19.22C23.1476 19.2648 23.1727 19.3256 23.1727 19.3889C23.1727 19.4523 23.1474 19.513 23.1025 19.5577L18.8688 23.7794Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5676 27.084L29.0399 26.5578C29.0176 26.5358 29 26.5093 28.9879 26.4804C28.9759 26.4515 28.9697 26.4205 28.9697 26.3891C28.9697 26.3576 28.9759 26.3267 28.9877 26.2977C28.9998 26.2686 29.0173 26.2424 29.0394 26.2201L33.1989 22.0488L33.7266 22.5751C33.8164 22.6645 33.8667 22.7858 33.8669 22.9125C33.8672 23.0391 33.8171 23.1608 33.7275 23.2505L29.9043 27.0847C29.8594 27.1296 29.7988 27.1546 29.7355 27.1549C29.6722 27.1549 29.6114 27.1298 29.5665 27.0852L29.5676 27.084Z",
    fill: "url(#paint4_linear_6237_277418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9594 19.2229L29.4855 18.6952C29.5304 18.6503 29.591 18.6251 29.6543 18.625C29.7176 18.6249 29.7785 18.65 29.8233 18.6947L33.7188 22.5792C33.8085 22.6687 33.8591 22.7901 33.8593 22.9167C33.8593 23.0434 33.8092 23.165 33.7199 23.2548L33.1935 23.7823L28.963 19.5639C28.9402 19.5419 28.9218 19.5155 28.9093 19.4864C28.8967 19.4573 28.8899 19.4259 28.8897 19.3942C28.8892 19.3624 28.8954 19.3309 28.9072 19.3015C28.9193 19.2721 28.937 19.2454 28.9594 19.2229Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3021 17.3835L27.4588 17.1136C27.3693 17.0849 27.2734 17.1343 27.2447 17.2239L23.8085 27.9576C23.7798 28.0473 23.8292 28.1432 23.9187 28.1719L24.7617 28.4419C24.8514 28.4706 24.9473 28.4211 24.976 28.3314L28.4123 17.5977C28.441 17.5081 28.3916 17.4122 28.3021 17.3835Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6237_277418",
    x1: 16.1859,
    y1: 22.8575,
    x2: 16.1859,
    y2: 0.00460403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#22A5CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#29BADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#2EC9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#31D1F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#32D4F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6237_277418",
    x1: 26.035,
    y1: 33.1007,
    x2: 26.035,
    y2: 13.5723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5EA0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6237_277418",
    x1: 26.0352,
    y1: 40.6352,
    x2: 26.0352,
    y2: 33.1006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#707070"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6237_277418",
    x1: 18.2075,
    y1: 24.6027,
    x2: 23.1065,
    y2: 24.6027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5EA0EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372,
    stopColor: "#9FC6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#E4EFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6237_277418",
    x1: 28.969,
    y1: 24.6031,
    x2: 33.8665,
    y2: 24.6031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#E4EFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628,
    stopColor: "#9FC6F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EA0EF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6237_277418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDevBox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dev-box.6ad37c855fe54dfad1b73459ca4a5da5.svg";